var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('creator-gallery-guide-content'),_c('div',{staticClass:"text-center branded py-3"},[_c('font-awesome-icon',{attrs:{"icon":"fa-light fa-arrow-down","size":"2x"}})],1),_c('b-btn',{attrs:{"variant":"primary","pill":"","block":"","size":"lg"},on:{"click":_vm.createGallery}},[_vm._v(" "+_vm._s(_vm.$t("Create My First Gallery"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }